import { MagicIncomingWindowMessage } from '@magic-sdk/types';
var ViewController = /** @class */ (function () {
    function ViewController(transport) {
        this.transport = transport;
        // Get the `endpoint` and `parameters` value
        // from the underlying `transport` instance.
        this.endpoint = transport.endpoint;
        this.parameters = transport.parameters;
        // Create a promise that resolves when
        // the view is ready for messages.
        this.ready = this.waitForReady();
        if (this.init)
            this.init();
        this.listen();
    }
    ViewController.prototype.waitForReady = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.transport.on(MagicIncomingWindowMessage.MAGIC_OVERLAY_READY, function () { return resolve(); });
        });
    };
    /**
     * Listen for messages sent from the underlying Magic `<WebView>`.
     */
    ViewController.prototype.listen = function () {
        var _this = this;
        this.transport.on(MagicIncomingWindowMessage.MAGIC_HIDE_OVERLAY, function () {
            _this.hideOverlay();
        });
        this.transport.on(MagicIncomingWindowMessage.MAGIC_SHOW_OVERLAY, function () {
            _this.showOverlay();
        });
    };
    return ViewController;
}());
export { ViewController };
//# sourceMappingURL=view-controller.js.map